import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import ContentLoading from "components/common/ContentLoading";
import ProductKit from "interfaces/ProductKit";
import * as numeral from "numeral";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import StandardSalesLine from "../../interfaces/StandardSalesLine";

interface RouteParams {
    id: number;
}

interface State {
    isLoading: boolean;
    errorMessage?: string;
    data: ProductKit;
}

export default class View extends React.Component<
    RouteComponentProps<RouteParams>,
    State
> {
    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);

        this.state = {
            isLoading: true,
            errorMessage: undefined,
            data: {
                id: 0,
                code: "",
                description: "",
                standardSalesLines: [],
            },
        };
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }


        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink to="/kits">Kits</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>
                            {this.state.data.code}
                        </BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <h3 className="card__title">{this.state.data.description}</h3>
                    <div className="box">
                        <div className="full-width">
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">ID</span>
                                    <span className="field-item">
                                        {this.state.data.id}
                                    </span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Code</span>
                                    <span className="field-item">
                                        {this.state.data.code}
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Number</span>
                                    <span className="field-item">{this.state.data.number}</span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Description</span>
                                    <span className="field-item">{this.state.data.description}</span>
                                </div>
                            </div>
                            <h5 className="section-seprate">Items</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Line Number</th>
                                            <th>Type</th>
                                            <th>Number</th>
                                            <th>Item Name</th>
                                            <th>Quantity</th>
                                            <th>UM</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.standardSalesLines.map((kitItem, index) => (
                                            <tr key={index}>
                                                <td>{kitItem.lineNo}</td>
                                                <td>{kitItem.type}</td>
                                                <td>{kitItem.no}</td>
                                                <td>{kitItem.description}</td>
                                                <td>{kitItem.quantity}</td>
                                                <td>{kitItem.unitOfMeasureCode}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        if (this.state.isLoading) {
            let response = await apifetch(
                "kits/" + this.props.match.params.id,
                undefined,
                true
            );
            if (response.ok) {
                let data = (await response.json()) as ProductKit;
                this.setState({
                    isLoading: false,
                    data: data,
                });

                document.title = `${this.state.data.code} - Kits - ${SITE_NAME}`;
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isLoading: false,
                    errorMessage: errorText,
                });
            }
        }
    }
}





// WEBPACK FOOTER //
// ./ClientApp/components/kits/View.tsx